<template>
  <v-dialog v-model="dialog" width="600px" :fullscreen="$vuetify.breakpoint.smAndDown" scrollable>
    <BaseBodyDialog :title="getNameTitle(type)" @close="dialog = false" @save="type === 'edit' ? onUpdate() : onCreate()">
      <v-form ref="form" class="mt-4">
        <v-text-field
          outlined
          dense
          v-model="title"
          class="required mt-4 pb-4"
          :rules="[$rules.required]"
          label="Tên Bộ môn"
          hide-details
        />
        <div v-if="type === 'create'">
          <v-autocomplete
            v-model="parent"
            item-text="title"
            item-value="id"
            label="Bộ môn cha"
            :items="academicParents"
            outlined
            dense
            hide-details
          ></v-autocomplete>
        </div>
      </v-form>
    </BaseBodyDialog>
  </v-dialog>
</template>

<script>
import BaseBodyDialog from '@/components/basic/dialog/BaseBodyDialog.vue'
import { mapActions } from 'vuex'
export default {
  components: {
    BaseBodyDialog
  },
  props: {
    state: Boolean,
  },
  data() {
    return {
      dialog: false,
      type: '',
      title: '',
      id: '',
      academicParents: [],
      parent: '',
    }
  },
  methods: {
    ...mapActions({
      create: 'AcademicLevel/createAcademic',
      update: 'AcademicLevel/updateAcademic',
      fetch: 'AcademicLevel/fetchAcademics',
      fetchAcademicsWithChild: 'AcademicLevel/fetchAcademicsWithChild',
    }),
    async openDialog(type, item) {
      this.type = type
      this.dialog = true
      const academics = await this.fetch({ notSetStore: true, type: 'parent' })
      this.academicParents = academics
      if (type === 'edit') {
        this.title = item.title
        this.id = item.id
      } else {
        this.title = ''
      }
    },
    async onCreate() {
      try {
        this.$loading.active = true
        const data = {
          title: this.title,
        }
        if (this.type === 'create') {
          if (this.parent) {
            data.parent = this.parent
            data.type = 'child'
          } else {
            data.type = 'parent'
          }
        }
        if (this.type === 'create') await this.create(data)
        this.$alert.success('Thêm mới thành công')
        this.dialog = false
        this.fetchAcademicsWithChild()
      } catch (error) {
        this.$alert.error(error)
      } finally {
        this.$loading.active = false
      }
    },
    async onUpdate() {
      try {
        this.$loading.active = true
        await this.update({ id: this.id, title: this.title })
        this.$alert.success('Thêm mới thành công')
        this.fetchAcademicsWithChild()
        this.dialog = false
      } catch (error) {
        this.$alert.error(error)
      } finally {
        this.$loading.active = false
      }
    },
    getNameTitle() {
      if (this.type === 'edit') return 'SỬA BỘ MÔN'
      if (this.type === 'create') return 'THÊM BỘ MÔN'
    },
  },
}
</script>
